function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-collateral-genrator",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Template_images",
  transform: "translate(-253.000000, -63.000000)",
  fill: "#215EFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Icon/check",
  transform: "translate(253.000000, 63.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M7.40900974,10.9016504 L5.81801948,9.3106602 C5.52512626,9.01776698 5.05025253,9.01776698 4.75735931,9.3106602 C4.46446609,9.60355343 4.46446609,10.0784271 4.75735931,10.3713203 L6.87867966,12.4926407 C7.02512626,12.6390873 7.217068,12.7123106 7.40900974,12.7123106 C7.6009515,12.7123106 7.79289322,12.6390873 7.9393398,12.4926407 L13.2426406,7.18933983 C13.5355339,6.89644661 13.5355339,6.42157288 13.2426406,6.12867966 C12.9497475,5.83578644 12.4748737,5.83578644 12.1819805,6.12867966 L7.40900974,10.9016504 Z M9,18 C4.02943725,18 0,13.9705628 0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705628,0 18,4.02943725 18,9 C18,13.9705628 13.9705628,18 9,18 Z",
  id: "Shape"
})))));

const SvgCheck = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.0373a1dc.svg";
export { ForwardRef as ReactComponent };